import React, { useContext, useState, useRef } from "react";
import { Link } from "react-router-dom";
import profile from "../../images/profile.gif";
import "../../css/ProfileEdit.css";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import ConfirmationModal from "../modals/ConfirmationModal";

const ProfileEdit = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false); // State to handle open/close of the accordion
  const [showModal, setShowModal] = useState(false);
  const [msgTitle, setMsgTitle] = useState("");
  const [message, setMessage] = useState("");

  const toggleAccordion = () => {
    setIsOpen(!isOpen); // Toggle the state on button click
  };
  const { user, loggedIN } = useContext(AppContext);

  const [errors, setErrors] = useState({});
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Trigger the file input click
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImageSrc(e.target.result); // Set the new image source
      };
      reader.readAsDataURL(file); // Read file as a Data URL
    }
  };

  const [profileData, setProfileData] = useState({
    name: user?.data?.name || "",
    email: user?.data?.email || "",
    mobile: user?.data?.mobile || "",
    role_name: user?.data?.role_name || "",
  });

  // Fetch Bearer token (Assuming it's stored in localStorage)
  const token = localStorage.getItem("authToken");

  const [imageSrc, setImageSrc] = useState(
    user?.data?.image
      ? process.env.REACT_APP_IMAGE_PATH_2 + "user/" + user?.data?.image
      : profile
  );

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files.length > 0) {
      // Handle image upload
      const file = files[0]; // Get the first selected file
      setProfileData((prevData) => ({
        ...prevData,
        [name]: file, // Store the file object in the state
      }));

      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setImageSrc(e.target.result); // Set preview image
        };
        reader.readAsDataURL(file); // Convert file to Data URL
      }
    } else if (name === "mobile") {
      // Ensure only numeric values for mobile input
      const numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
      if (numericValue.length > 10) return; // Limit to 10 digits

      setProfileData((prevData) => ({
        ...prevData,
        [name]: numericValue, // Store only numbers
      }));
    } else {
      // Handle regular text inputs
      setProfileData((prevData) => ({
        ...prevData,
        [name]: value, // Update other fields normally
      }));
    }
  };

  //alert(JSON.stringify(profileData));
  const validateInputs = () => {
    const newErrors = {};

    // Name validation
    if (!profileData.name?.trim()) {
      newErrors.name = "Name is required";
    }

    // Email validation (only validate format if email is provided)
    if (
      profileData.email?.trim() &&
      !/^\S+@\S+\.\S+$/.test(profileData.email)
    ) {
      newErrors.email = "Invalid email address";
    } else if (!profileData.email?.trim()) {
      newErrors.email = "Email is required";
    }

    // Mobile number validation
    if (!profileData.mobile?.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(profileData.mobile.trim())) {
      newErrors.mobile =
        "Mobile number must be exactly 10 digits and start with 6-9";
    }

    // Update errors state
    setErrors(newErrors);

    // Return true if no errors, false otherwise
    return Object.keys(newErrors).length === 0;
  };

  const saveChanges = async () => {
    if (!validateInputs()) return;

    try {
      const formData = new FormData();

      // Append profile data to FormData
      Object.keys(profileData).forEach((key) => {
        formData.append(key, profileData[key]);
      });

      // API call to save profile data including the image
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/editProfile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status) {
        //alert('hello');
        loggedIN(token, response.data);
        navigate("/myProfile?value=myProfile");
      } else {
        //alert(response.data.message || "Failed to update profile.");
        setShowModal(true);
        setMsgTitle(response.data.message || "Failed to update profile.");
        setMessage("");
      }
    } catch (error) {
      console.error("Error updating profile:", error);

      if (error.response) {
        const { data } = error.response;

        if (data.errors) {
          // Laravel returns validation errors in 'errors' object
          let errorMessage = Object.values(data.errors).flat().join("\n");
          //   alert(errorMessage);
          setShowModal(true);
          setMsgTitle(errorMessage);
          setMessage("");
        } else {
          // General server error message
          //   alert(data.message || "Failed to update profile.");
          setShowModal(true);
          setMsgTitle(data.message || "Failed to update profile.");
          setMessage("");
        }
      } else if (error.request) {
        // alert(
        //   "No response from server. Please check your internet connection."
        // );
        setShowModal(true);
        setMsgTitle(
          "No response from server. Please check your internet connection."
        );
        setMessage("");
      } else {
        // alert("An unexpected error occurred. Please try again.");
        setShowModal(true);
        setMsgTitle("An unexpected error occurred. Please try again.");
        setMessage("");
      }
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between ">
        <div className="title-header breadcrumb">
          <div className="profile-path">
            <span>Profile Edit</span>
          </div>
        </div>
        <div className=" border-bottom-0">
          <Link
            onClick={() => saveChanges()}
            className="text-decoration none btn profile-edit"
            style={{ minWidth: "136px" }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6003 0.0830078C10.9097 0.0830078 11.2064 0.205922 11.4252 0.424719L13.0751 2.07463C13.2939 2.29343 13.4168 2.59017 13.4168 2.89959V11.1663C13.4168 12.1329 12.6334 12.9163 11.6668 12.9163H2.3335C1.367 12.9163 0.583496 12.1329 0.583496 11.1663V1.83301C0.583496 0.866512 1.367 0.0830078 2.3335 0.0830078H10.6003ZM2.3335 1.24967C2.01133 1.24967 1.75016 1.51084 1.75016 1.83301V11.1663C1.75016 11.4885 2.01133 11.7497 2.3335 11.7497H2.91683V8.24967C2.91683 7.28315 3.70033 6.49967 4.66683 6.49967H9.3335C10.3 6.49967 11.0835 7.28315 11.0835 8.24967V11.7497H11.6668C11.989 11.7497 12.2502 11.4885 12.2502 11.1663V3.48293C12.2502 3.1735 12.1273 2.87676 11.9084 2.65796L10.8419 1.59139C10.6231 1.37259 10.3263 1.24967 10.0169 1.24967H9.91683V2.41634C9.91683 3.38284 9.13336 4.16634 8.16683 4.16634H5.8335C4.867 4.16634 4.0835 3.38284 4.0835 2.41634V1.24967H2.3335ZM9.91683 11.7497V8.24967C9.91683 7.9275 9.65567 7.66634 9.3335 7.66634H4.66683C4.34467 7.66634 4.0835 7.9275 4.0835 8.24967V11.7497H9.91683ZM5.25016 1.24967H8.75016V2.41634C8.75016 2.7385 8.48901 2.99967 8.16683 2.99967H5.8335C5.51133 2.99967 5.25016 2.7385 5.25016 2.41634V1.24967Z"
                fill="white"
              />
            </svg>
            Save Details
          </Link>
        </div>
      </div>
      <div className="main-area pt-4 pb-4">
        <div className="d-grid ">
          <div className="mid-profile-img">
            <img
              src={imageSrc}
              className="img-fluid"
              alt="DreamSakha"
              onError={(e) => {
                e.target.onerror = null; // Prevents infinite loop in case the default image fails
                e.target.src = profile; // Default profile image path
              }}
            />
          </div>

          <button
            type="button"
            className="btn upload-photo-btn mt-3"
            onClick={handleButtonClick}
          >
            Upload your Photo
          </button>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }} // Hide the file input
            name="image"
            onChange={handleChange}
          />
        </div>

        <div className="w-100 pt-3">
          <div className="d-grid ">
            <div className="profile-edit-descrption">
              <p className="profile-description-key">Name</p>
              <div className="profinputbx d-grid">
                <input
                  type="text"
                  name="name"
                  value={profileData.name}
                  onChange={handleChange}
                />
                <span className="lb-sm text-danger">{errors?.name}</span>
              </div>
            </div>

            <div className="profile-edit-descrption">
              <p className="profile-description-key">Email Address</p>
              <div className="profinputbx d-grid">
                <input
                  type="text"
                  name="email"
                  value={profileData.email}
                  onChange={handleChange}
                />
                <span className="lb-sm text-danger">{errors?.email}</span>
              </div>
            </div>
            <div className="profile-edit-descrption">
              <p className="profile-description-key">Phone No.</p>
              <div className="profinputbx d-grid">
                <div>
                  <input
                    type="text"
                    name="mobile"
                    value={profileData.mobile}
                    onChange={handleChange}
                  />
                </div>
                <span className="lb-sm text-danger">{errors?.mobile}</span>
              </div>
            </div>
            <div className="profile-edit-descrption">
              <p className="profile-description-key">Registered As</p>
              <div className="profinputbx d-grid">
                <input
                  type="text"
                  className="bg-light"
                  value={profileData.role_name}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <ConfirmationModal
          onClose={() => setShowModal(false)}
          title={msgTitle}
          message={message}
          icon="fa fa-times-circle-o"
          theme="red"
        />
      )}
    </div>
  );
};

export default ProfileEdit;
